import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Quote } from 'lucide-react';
import { HeroSlideshow } from '../components/HeroSlideshow';
import { ParallaxSection } from '../components/ParallaxSection';
import { ProjectShowcase } from '../components/ProjectShowcase';
import { DevelopmentAreas } from '../components/DevelopmentAreas';
import { BrandFamily } from '../components/BrandFamily';
export function HomePage() {
  return <div className="bg-white" data-id="element-282" data-mp="2wy62cyy08p1f">
      <HeroSlideshow data-id="element-283" data-mp="2s279oz5n8kv7" />

      {/* Positioning statement */}
      <section className="py-24 px-6 md:px-10 bg-white" data-id="element-284" data-mp="2rzl2j0mo07di">
        <div className="max-w-5xl mx-auto" data-id="element-285" data-mp="36r3rhnxi5c90">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-286" data-mp="36s55o19teeuy">
            <h2 className="text-4xl md:text-6xl font-serif font-bold text-black leading-tight mb-8" data-id="element-287" data-mp="299vceqtuk9rx">
              From opportunity to completion.
            </h2>
            <div className="w-16 h-[2px] bg-[#C5A55A] mb-8" data-id="element-288" data-mp="2eq8axa2gfh48" />
            <p className="text-xl md:text-2xl text-gray-700 font-light leading-relaxed max-w-3xl" data-id="element-289" data-mp="2eonipr3m4a9j">
              Sinclair Development identifies opportunities and brings together
              the planning, design, construction and management necessary to
              turn them into successful properties throughout Southwest Florida.
            </p>
          </motion.div>
        </div>
      </section>

      <ProjectShowcase data-id="element-290" data-mp="1vtoxi8kmb71v" />

      <DevelopmentAreas data-id="element-291" data-mp="20qp54nx48hv3" />

      <BrandFamily data-id="element-292" data-mp="20qfmxmibbezy" />

      {/* Testimonial */}
      <section className="py-24 px-6 md:px-10 bg-black text-white" data-id="element-293" data-mp="20ss5o1vw9te2">
        <div className="max-w-4xl mx-auto text-center" data-id="element-294" data-mp="25ql76hm95z80">
          <Quote className="w-12 h-12 text-[#C5A55A] mx-auto mb-8" aria-hidden="true" data-id="element-295" data-mp="3c64bgib7sm2v" />
          <blockquote className="text-2xl md:text-3xl font-serif italic leading-relaxed mb-8 text-gray-100" data-id="element-296" data-mp="3h45tczwwmfcr">
            "Sinclair didn't just build our headquarters; they created a
            landmark. Their attention to detail and commitment to excellence is
            unmatched in the industry."
          </blockquote>
          <div className="text-[#C5A55A] font-bold tracking-[0.2em] uppercase text-sm" data-id="element-297" data-mp="31eh8b9cwxvps">
            Jon Engh
          </div>
          <div className="text-gray-500 text-sm mt-2" data-id="element-298" data-mp="2wdthoosljgw3">
            Senior Vice President, First Horizon Bank
          </div>
        </div>
      </section>

      {/* CTA */}
      <ParallaxSection backgroundImage="https://images.unsplash.com/photo-1590274853856-f22d5ee3d228?w=1920&q=80" height="h-[60vh]" data-id="element-299" data-mp="23ssa3owzjxz2">
        <div className="text-center" data-id="element-300" data-mp="2dpoi7tiz2i33">
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-301" data-mp="2don0553jgvbv">
            Sinclair Develops.
          </h2>
          <p className="text-xl text-gray-200 mb-10 max-w-2xl mx-auto" data-id="element-302" data-mp="1pxhhyja4lqye">
            Have land, a building or an opportunity in Southwest Florida? Let's
            look at what it can become.
          </p>
          <Link to="/contact" className="inline-block bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-10 py-4 text-lg font-bold rounded-sm transition-colors duration-200" data-id="element-303" data-mp="gvokeufbody">
            Start the conversation
          </Link>
        </div>
      </ParallaxSection>
    </div>;
}